var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`component_template__maintenance_mode`},[_c('div',{staticClass:"d-block p-2 mb-2"},[_c('div',{staticClass:"separator"},[_vm._v(" Maintenance mode (frontend) ")]),_c('div',{staticClass:"card p-2 server-information mb-2"},[_c('b-form-checkbox',[_vm._v(" Inative ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }